export enum ExecutePaymentOrderActionTypes {
  EXECUTED = 'payment/EXECUTED',
  EXECUTING = 'payment/EXECUTING',
}
